import { JobUtil } from '@xengage/gw-portals-util-js';

export default {
    // Platform JobUtil functions
    getJobDetailURLByJobType: JobUtil.getJobDetailURLByJobType,
    openJobInXCenter: JobUtil.openJobInXCenter,
    isSupportJobType: JobUtil.isSupportJobType
};
